(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvDelayedLoad', function(vv, vvService) {
    return {
      transclude: true,
      scope: {
        vvStartLoad: '&'
      },
      template: '<ng-transclude ng-if="startLoad"></ng-transclude>',
      link: function(scope, element, attrs) {
        if (vv.feature.disableDelayedLoad) {
          scope.startLoad = true;
          scope.vvStartLoad();
        } else {
          scope.startLoad = false;
          vvService.windowLoad(function () {
            scope.startLoad = true;
            scope.vvStartLoad();
          });
        }
      }
    };
  });
})(window, window.angular);
